export const transactionType = {
  CREDIT: "CREDIT",
  DEBIT: "DEBIT",
  MANUAL_CREDIT: "MANUAL CREDIT",
  MANUAL_DEBIT: "MANUAL DEBIT",
  AUTO_REVERSAL: "AUTO REVERSAL",
  MANUAL_REVERSAL: "MANUAL REVERSAL",
  ADD_CREDIT_LIMIT: "ADD CREDIT LIMIT",
  REDUCE_CREDIT_LIMIT: "REDUCE CREDIT LIMIT",
  ADD_LIEN: "ADD LIEN",
  REDUCE_LIEN: "REDUCE LIEN",
};
export const ADMIN = "admin";
export const ISSUPERADMIN = "superAdmin";
export const MOBILE = "Mobile";
export const TXNID = "Transaction ID";
export const REQID = "Request ID";
export const UTR = "UTR";
export const VPA = "VPA";
export const AMOUNT = "AMOUNT";
export const ODRCODE = "ORDER CODE";
export const TICKETID = "Ticket ID/Txn ID";
export const setpageContent = (currentPage, finalLength, totalPost) => {
  const firstIndex = currentPage == 0 ? 1 : currentPage * 20;
  const finalIndex = currentPage == 0 ? 20 : firstIndex + finalLength;
  return `Showing ${firstIndex} to ${finalIndex} of  ${totalPost}`;
};
export const createdOnDate = (date) => {
  return date.split(".")[0].replace("T", " ");
};
export const searchbyOptionsForTicket = [TICKETID];
export const TicketStatusoptions = [
  { value: "NEW", label: "NEW" },
  { value: "INPROGRESS", label: "INPROGRESS" },

  { value: "CLOSED", label: "CLOSED" },
  // { value: "FAILED", label: "FAILED" },
];
export const isNotSuccess = (status) => {
  const successStatus = [
    "SUCCESS_AUTO",
    "SUCCESS_MANUAL",
    "SUCCESS_INCOMPLETE",
    "SUCCESS_FROM_FAILED",
    "UNPROCESSED",
    "SYS_ERROR",
    "REVERSED",
    "CANCELED",
  ];
  if (successStatus.includes(status)) {
    return false;
  } else {
    return true;
  }
};
